import { useRef, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import styles from './AchievementsSection.module.scss'
import SectionTitle from '../SectionTitle/SectionTitle'
import Button from '../Button/Button'

export default function AchievementsSection() {
    const swiperRef = useRef(null)
    const prevRef = useRef(null)
    const nextRef = useRef(null)
	const API_PREFIX = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    const [achievements, setAchievements] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const isTouchDevice = () =>
        'ontouchstart' in window || navigator.maxTouchPoints > 0

    const handleButtonEffect = (e) => {
        if (!e.currentTarget) return
        e.currentTarget.classList.add(styles.active)
        setTimeout(() => {
            if (e.currentTarget) {
                e.currentTarget.classList.remove(styles.active)
            }
        }, 300)
    }

    useEffect(() => {
        fetch(`${API_PREFIX}/api/sections/get/achievements/list`)
            .then((res) => {
                if (!res.ok) throw new Error('Ошибка загрузки')
                return res.json()
            })
            .then((data) => {
                setAchievements(data.achievements ?? [])
                setLoading(false)
            })
            .catch((e) => {
                setError(e.message)
                setLoading(false)
            })
    }, [])

    useEffect(() => {
        if (swiperRef.current && swiperRef.current.swiper) {
            const swiper = swiperRef.current.swiper
            swiper.params.navigation.prevEl = prevRef.current
            swiper.params.navigation.nextEl = nextRef.current
            swiper.navigation.destroy()
            swiper.navigation.init()
            swiper.navigation.update()
        }
    }, [achievements])

    return (
        <section className={styles.achievements}>
            <div className={`container ${styles.achievements__container}`}>
                <SectionTitle>Наши достижения</SectionTitle>
                {loading && <div>Загрузка...</div>}
                {error && <div style={{ color: 'red' }}>Ошибка: {error}</div>}

                {!loading && !error && achievements.length > 0 && (
                    <Swiper
                        ref={swiperRef}
                        modules={[Navigation]}
                        spaceBetween={24}
                        grabCursor={true}
                        slidesPerView={1}
                        loop={true}
                        navigation={{
                            prevEl: prevRef.current,
                            nextEl: nextRef.current,
                        }}
                        onSwiper={(swiper) => {
                            swiper.params.navigation.prevEl = prevRef.current
                            swiper.params.navigation.nextEl = nextRef.current
                            swiper.navigation.init()
                            swiper.navigation.update()
                        }}
                    >
                        {achievements.map((item, index) => (
                            <SwiperSlide key={item.id ?? index}>
                                <div className={styles.achievementSlide}>

                                    {/* Фото: размытый фон + чёткое фото поверх */}
                                    <div className={styles.achievementMedia}>
                                        {/* нижний слой — размытый фон, заполняет пространство */}
                                        <img
                                            src={item.img}
                                            alt=''
                                            className={styles.achievementBg}
                                            aria-hidden='true'
                                        />
                                        {/* верхний слой — оригинал целиком, без обрезки */}
                                        <img
                                            src={item.img}
                                            alt={item.title}
                                            className={styles.achievementImage}
                                            loading='lazy'
                                        />
                                    </div>

                                    {/* Текст + кнопка */}
                                    <div className={styles.achievementText}>
                                        <div className={styles.achievementTextContent}>
                                            <h3>{item.title}</h3>
                                            <p>{item.text}</p>
                                        </div>
                                        <div className={styles.progiumButtons}>
                                            <a href='#form'>
                                                <Button />
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                )}

                <div className={styles.achievementSliderNavigation}>
                    <div
                        className={styles.achievementSliderButtonPrev}
                        ref={prevRef}
                        onClick={() => swiperRef.current?.swiper.slidePrev()}
                    >
                        <div
                            className={styles.btnContainer}
                            {...(isTouchDevice()
                                ? { onTouchStart: handleButtonEffect }
                                : { onMouseDown: handleButtonEffect })}
                        >
                            <div className={styles.consultBtn}>
                                <img src='/img/slider/arrow-left.svg' alt='' />
                            </div>
                        </div>
                    </div>
                    <div
                        className={styles.achievementSliderButtonNext}
                        ref={nextRef}
                        onClick={() => swiperRef.current?.swiper.slideNext()}
                    >
                        <div
                            className={styles.btnContainer}
                            {...(isTouchDevice()
                                ? { onTouchStart: handleButtonEffect }
                                : { onMouseDown: handleButtonEffect })}
                        >
                            <div className={styles.consultBtn}>
                                <img src='/img/slider/arrow-right.svg' alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
